import Homepage from '../enums/homepage';
import { UrlParameters as Up } from '../enums/url-parameters';

export const ROUTES = {
  HOMEPAGE: '/',
  INFOPAGE: Homepage.url,
  ABOUT: Homepage.url + '/sistema/',
  CONTACTS: '/contacts',
  TERMS: Homepage.url + '/lietosanas-noteikumi/',
  PRIVACY: Homepage.url + '/privatuma-politika/',
  HELP: Homepage.url + '/palidziba/',
  LAD_EPS: 'https://eps.lad.gov.lv/login',

  LOGIN: '/login',
  LATVIJA_LV_AUTH: '/auth/latvija',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  DASHBOARD: '/farms/' + Up.FARM_ID + '/dashboard',
  ARTICLES_VIEW: '/article/:id',
  EVENTS_VIEW: '/events/:id',

  TOKENS_INDEX: '/tokens',
  TOKENS_CREATE: '/tokens/create',
  TOKENS_VIEW: '/tokens/view/:id',
  TOKENS_EDIT: '/tokens/edit/:id',

  PROFILE: '/profile',
  PROFILE_CHANGE_EMAIL: '/profile/change-email',
  PROFILE_CHANGE_PASSWORD: '/profile/change-password',
  PROFILE_CHANGE_PHONE: '/profile/change-phone',

  FARM_VIEW: '/farms/view/' + Up.FARM_ID + '',
  FARM_EDIT: '/farms/edit/' + Up.FARM_ID + '',

  FARM_USERS_INDEX: '/farms/' + Up.FARM_ID + '/users',
  FARM_USERS_CREATE: '/farms/' + Up.FARM_ID + '/users/create',
  FARM_USERS_VIEW: '/farms/' + Up.FARM_ID + '/users/view/:id',
  FARM_USERS_EDIT: '/farms/' + Up.FARM_ID + '/users/edit/:id',

  CROP_COUNTRY_MAPS: '/farms/' + Up.FARM_ID + '/crop/:season/country-maps',
  CROP_FIELDS_AND_WORKS_INDEX:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/:tab',
  CROP_FIELD_VIEW:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/fields-and-works/fields/view/:id/:tab',
  CROP_FIELD_EDIT:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/fields/edit/:id',
  CROP_FIELD_CREATE:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/fields/create',
  CROP_FIELD_CREATE_LAD:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/fields-and-works/fields/create?lad=1',
  CROP_FIELD_IMPORT:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/fields/import',
  CROP_FIELDS_MERGE:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/fields/merge',
  CROP_FIELD_SPLIT:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/fields/:id/split',
  CROP_FIELD_ANALYSES_VIEW:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/fields-and-works/fields/view/:id/analyses',
  CROP_WORK_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/fields-and-works/works/create/:type',
  CROP_WORK_VIEW:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/works/view/:id',
  CROP_WORK_EDIT:
    '/farms/' + Up.FARM_ID + '/crop/:season/fields-and-works/works/edit/:id',
  CROP_FIELD_HISTORY:
    '/farms/' + Up.FARM_ID + '/crop/:season/field-history/:tab',
  CROP_FIELD_HISTORY_VIEW:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/field-history/history/view/:id/:tab',
  CROP_FIELD_HISTORY_OVERVIEW:
    '/farms/' + Up.FARM_ID + '/crop/:season/field-history/:tab/:dataset',

  CROP_YIELD_ACCOUNTING_CARGO_INDEX:
    '/farms/' + Up.FARM_ID + '/crop/:season/yield-accounting/:yield_id/cargo',
  CROP_YIELD_ACCOUNTING_CARGO_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/yield-accounting/:yieldId/cargo/create',
  CROP_YIELD_ACCOUNTING_CARGO_VIEW:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/yield-accounting/:yieldId/cargo/view/:id',
  CROP_YIELD_ACCOUNTING_CARGO_EDIT:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/yield-accounting/:yieldId/cargo/edit/:id',
  CROP_YIELD_ACCOUNTING_INDEX:
    '/farms/' + Up.FARM_ID + '/crop/:season/yield-accounting/:tab',
  CROP_CHANGE_PLAN_INDEX:
    '/farms/' + Up.FARM_ID + '/crop/:season/crop-change-plan',
  CROP_CHANGE_PLAN_CREATE:
    '/farms/' + Up.FARM_ID + '/crop/:season/crop-change-plan/create',
  CROP_CHANGE_PLAN_VIEW:
    '/farms/' + Up.FARM_ID + '/crop/:season/crop-change-plan/view/:id',
  CROP_CHANGE_PLAN_EDIT:
    '/farms/' + Up.FARM_ID + '/crop/:season/crop-change-plan/edit/:id',
  CROP_FERTILIZATION_PLAN:
    '/farms/' + Up.FARM_ID + '/crop/:season/fertilization-plan/:tab',
  CROP_FERTILIZATION_PLAN_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/crop/:season/fertilization-plan/plan/create/:fieldId',
  CROP_FERTILIZATION_PLAN_VIEW:
    '/farms/' + Up.FARM_ID + '/crop/:season/fertilization-plan/plan/view/:id',
  CROP_FERTILIZATION_PLAN_EDIT:
    '/farms/' + Up.FARM_ID + '/crop/:season/fertilization-plan/plan/edit/:id',

  WAREHOUSE_MOVEMENT_INDEX: '/farms/' + Up.FARM_ID + '/warehouse/movement/:tab',
  WAREHOUSE_DEAL_CREATE:
    '/farms/' + Up.FARM_ID + '/warehouse/movement/deals/:dealType/create',
  WAREHOUSE_DEAL_VIEW:
    '/farms/' + Up.FARM_ID + '/warehouse/movement/deals/:dealType/view/:id',
  WAREHOUSE_DEAL_EDIT:
    '/farms/' + Up.FARM_ID + '/warehouse/movement/deals/:dealType/edit/:id',
  WAREHOUSE_DEAL_COPY:
    '/farms/' + Up.FARM_ID + '/warehouse/movement/deals/:dealType/copy/:id',

  WAREHOUSE_PRODUCTS_INDEX:
    '/farms/' + Up.FARM_ID + '/warehouse/products/:obtainTypeId',
  WAREHOUSE_PRODUCTS_COPY:
    '/farms/' + Up.FARM_ID + '/warehouse/products/:obtainTypeId/copy/:id',
  WAREHOUSE_PRODUCTS_CREATE:
    '/farms/' + Up.FARM_ID + '/warehouse/products/:obtainTypeId/create',
  WAREHOUSE_PRODUCTS_VIEW:
    '/farms/' + Up.FARM_ID + '/warehouse/products/:obtainTypeId/view/:id',
  WAREHOUSE_PRODUCTS_EDIT:
    '/farms/' + Up.FARM_ID + '/warehouse/products/:obtainTypeId/edit/:id',

  WAREHOUSE_WAREHOUSES_INDEX: '/farms/' + Up.FARM_ID + '/warehouse/warehouses',
  WAREHOUSE_WAREHOUSES_CREATE:
    '/farms/' + Up.FARM_ID + '/warehouse/warehouses/create',
  WAREHOUSE_WAREHOUSES_VIEW:
    '/farms/' + Up.FARM_ID + '/warehouse/warehouses/view/:id',
  WAREHOUSE_WAREHOUSES_EDIT:
    '/farms/' + Up.FARM_ID + '/warehouse/warehouses/edit/:id',

  HUMAN_EMPLOYEES_INDEX: '/farms/' + Up.FARM_ID + '/human/employees',
  HUMAN_EMPLOYEES_CREATE: '/farms/' + Up.FARM_ID + '/human/employees/create',
  HUMAN_EMPLOYEES_VIEW: '/farms/' + Up.FARM_ID + '/human/employees/view/:id',
  HUMAN_EMPLOYEES_EDIT: '/farms/' + Up.FARM_ID + '/human/employees/edit/:id',
  HUMAN_PARTNERS_INDEX: '/farms/' + Up.FARM_ID + '/human/partners',
  HUMAN_PARTNERS_CREATE: '/farms/' + Up.FARM_ID + '/human/partners/create',
  HUMAN_PARTNERS_VIEW: '/farms/' + Up.FARM_ID + '/human/partners/view/:id',
  HUMAN_PARTNERS_EDIT: '/farms/' + Up.FARM_ID + '/human/partners/edit/:id',
  HUMAN_PARTNER_DEPARTMENTS_CREATE:
    '/farms/' + Up.FARM_ID + '/human/partners/:partnerId/departments/create',
  HUMAN_PARTNER_DEPARTMENTS_EDIT:
    '/farms/' + Up.FARM_ID + '/human/partners/:partnerId/departments/edit/:id',

  FINANCE_ANALYSIS_INDEX: '/farms/' + Up.FARM_ID + '/finance/analysis',
  FINANCE_BUDGET_INDEX: '/farms/' + Up.FARM_ID + '/finance/budget/:season/:tab',
  FINANCE_MODELING_INDEX: '/farms/' + Up.FARM_ID + '/finance/modeling/:type',

  EQUIPMENT_LIST_INDEX:
    '/farms/' + Up.FARM_ID + '/equipment/list/:equipmentType',
  EQUIPMENT_LIST_CREATE:
    '/farms/' + Up.FARM_ID + '/equipment/list/:equipmentType/create',
  EQUIPMENT_LIST_VIEW:
    '/farms/' + Up.FARM_ID + '/equipment/list/:equipmentType/view/:id',
  EQUIPMENT_LIST_EDIT:
    '/farms/' + Up.FARM_ID + '/equipment/list/:equipmentType/edit/:id',

  EQUIPMENT_MAINTENANCE_INDEX:
    '/farms/' + Up.FARM_ID + '/equipment/maintenance-repairs',
  EQUIPMENT_MAINTENANCE_CREATE:
    '/farms/' + Up.FARM_ID + '/equipment/maintenance-repairs/create',
  EQUIPMENT_MAINTENANCE_VIEW:
    '/farms/' + Up.FARM_ID + '/equipment/maintenance-repairs/view/:id',
  EQUIPMENT_MAINTENANCE_EDIT:
    '/farms/' + Up.FARM_ID + '/equipment/maintenance-repairs/edit/:id',
  EQUIPMENT_FUEL_CONSUMPTION: '/equipment/fuel-consumption',

  REPORTING_BIOLOGICAL_FARMING_INDEX:
    '/farms/' + Up.FARM_ID + '/reports/biological_farming',

  REPORTING_REPORT_JOURNALS_INDEX:
    '/farms/' + Up.FARM_ID + '/reports/report-journals',

  REPORTING_VAAD_LIZ_REPORTS:
    '/farms/' + Up.FARM_ID + '/reports/vaad-liz-reports/:year',
  REPORTING_VAAD_LIZ_REPORTS_CREATE:
    '/farms/' + Up.FARM_ID + '/reports/vaad-liz-reports/:year/create/:id',
  REPORTING_VAAD_LIZ_REPORTS_VIEW:
    '/farms/' + Up.FARM_ID + '/reports/vaad-liz-reports/:year/view/:id',
  REPORTING_VAAD_LIZ_REPORTS_UPDATE:
    '/farms/' + Up.FARM_ID + '/reports/vaad-liz-reports/:year/update/:id',

  INTERNAL_LOGIN: '/internal/login',
  INTERNAL_DASHBOARD: '/internal/dashboard',

  INTERNAL_HORIZON: '/internal/horizon/dashboard',

  INTERNAL_AUDIT_LOGS_INDEX: '/internal/audit-logs',
  INTERNAL_AUDIT_LOGS_VIEW: '/internal/audit-logs/view/:id',

  INTERNAL_USERS_INDEX: '/internal/users',
  INTERNAL_USERS_CREATE: '/internal/users/create',
  INTERNAL_USERS_VIEW: '/internal/users/view/:id',
  INTERNAL_USERS_EDIT: '/internal/users/edit/:id',

  INTERNAL_ROLES_INDEX: '/internal/roles',
  INTERNAL_ROLES_CREATE: '/internal/roles/create',
  INTERNAL_ROLES_VIEW: '/internal/roles/view/:id',
  INTERNAL_ROLES_EDIT: '/internal/roles/edit/:id',

  INTERNAL_ARTICLES_INDEX: '/internal/articles',
  INTERNAL_ARTICLES_CREATE: '/internal/articles/create',
  INTERNAL_ARTICLES_VIEW: '/internal/articles/view/:id',
  INTERNAL_ARTICLES_EDIT: '/internal/articles/edit/:id',

  INTERNAL_EVENTS_INDEX: '/internal/events',
  INTERNAL_EVENTS_CREATE: '/internal/events/create',
  INTERNAL_EVENTS_VIEW: '/internal/events/view/:id',
  INTERNAL_EVENTS_EDIT: '/internal/events/edit/:id',

  INTERNAL_CLASSIFIERS_INDEX: '/internal/classifier-groups/:groupKey',
  INTERNAL_CLASSIFIER_VALUES:
    '/internal/classifier-groups/:groupKey/classifiers/:classifierId/values',
  INTERNAL_CLASSIFIER_VALUE_CREATE:
    '/internal/classifier-groups/:groupKey/classifiers/:classifierId/values/create',
  INTERNAL_CLASSIFIER_VALUE_VIEW:
    '/internal/classifier-groups/:groupKey/classifiers/:classifierId/values/:id/view',
  INTERNAL_CLASSIFIER_VALUE_EDIT:
    '/internal/classifier-groups/:groupKey/classifiers/:classifierId/values/:id/edit',

  INTERNAL_CLASSIFIER_VALUE_CHILD_CREATE:
    '/internal/classifier-groups/:groupKey/classifiers/:classifierId/values/parent/:parentValueId/create',

  INTERNAL_EMAIL_TEMPLATE_INDEX: '/internal/email-templates',
  INTERNAL_EMAIL_TEMPLATE_EDIT: '/internal/email-templates/edit/:id',

  INTERNAL_SYSTEM_PROPERTIES_INDEX: '/internal/system-configurations',
  INTERNAL_SYSTEM_PROPERTIES_EDIT: '/internal/system-configurations/edit/:id',

  INTERNAL_DEVELOPMENT_SANDBOX: '/internal/development/sandbox',

  SYSTEM_FILE: '/api/system-configurations/:systemCfgKey/file',

  LIVESTOCK_ANIMALS_AND_EVENTS_INDEX:
    '/farms/' + Up.FARM_ID + '/livestock/animals-and-events/:tab',
  LIVESTOCK_ANIMALS_CREATE:
    '/farms/' + Up.FARM_ID + '/livestock/animals/:animalType/create',
  LIVESTOCK_ANIMALS_VIEW: '/farms/' + Up.FARM_ID + '/livestock/animals/:id',
  LIVESTOCK_ANIMALS_EVENTS:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/:animalType/view/:id/:mode',
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/starter_feed/create',
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_EDIT:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/starter_feed/edit/:id',
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_VIEW:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/starter_feed/view/:id/:mode',
  LIVESTOCK_ANIMALS_GRAZING_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/grazing/create',
  LIVESTOCK_ANIMALS_GRAZING_EDIT:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/grazing/edit/:id`,
  LIVESTOCK_ANIMALS_GRAZING_VIEW:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/grazing/view/:id/:mode`,
  LIVESTOCK_ANIMALS_OTHER_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/other/create',
  LIVESTOCK_ANIMALS_OTHER_EDIT:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/other/edit/:id`,
  LIVESTOCK_ANIMALS_OTHER_VIEW:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/other/view/:id/:mode`,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/pregnancy/create',
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_EDIT:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/pregnancy/edit/:id`,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_VIEW:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/pregnancy/view/:id/:mode`,
  LIVESTOCK_ANIMALS_SEPARATION_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/separation/create',
  LIVESTOCK_ANIMALS_SEPARATION_EDIT:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/separation/edit/:id`,
  LIVESTOCK_ANIMALS_SEPARATION_VIEW:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/separation/view/:id/:mode`,
  LIVESTOCK_ANIMALS_BREEDING_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/breeding/create',
  LIVESTOCK_ANIMALS_BREEDING_EDIT:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/breeding/edit/:id`,
  LIVESTOCK_ANIMALS_BREEDING_VIEW:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/breeding/view/:id/:mode`,
  LIVESTOCK_ANIMALS_WEIGHING_CREATE:
    '/farms/' +
    Up.FARM_ID +
    '/livestock/animals-and-events/events/weighing/create',
  LIVESTOCK_ANIMALS_WEIGHING_EDIT:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/weighing/edit/:id`,
  LIVESTOCK_ANIMALS_WEIGHING_VIEW:
    '/farms/' +
    Up.FARM_ID +
    `/livestock/animals-and-events/events/weighing/view/:id/:mode`,
  LIVESTOCK_FODDER_NEED_INDEX:
    '/farms/' + Up.FARM_ID + '/livestock/fodder-need',
  LIVESTOCK_FODDER_NEED_CREATE:
    '/farms/' + Up.FARM_ID + '/livestock/fodder-need/create',
  LIVESTOCK_FODDER_NEED_EDIT:
    '/farms/' + Up.FARM_ID + '/livestock/fodder-need/edit/:id',
  LIVESTOCK_FODDER_NEED_VIEW:
    '/farms/' + Up.FARM_ID + '/livestock/fodder-need/view/:id',
  LIVESTOCK_SUMMARY_INDEX: '/farms/' + Up.FARM_ID + '/livestock/summary/:tab',
  LIVESTOCK_SUMMARY_VIEW:
    '/farms/' + Up.FARM_ID + '/livestock/summary/dairy/view/:id',
  LIVESTOCK_METABOLISM_VIEW:
    '/farms/' + Up.FARM_ID + '/livestock/summary/dairy/metabolism/view/:id',
  LIVESTOCK_SOMATIC_CELLS_VIEW:
    '/farms/' + Up.FARM_ID + '/livestock/summary/dairy/somatic-cells/view/:id',
  LIVESTOCK_REPRODUCTION_VIEW:
    '/farms/' + Up.FARM_ID + '/livestock/summary/dairy/reproduction/view/:id',

  DOCUMENT_STORAGE_INDEX: '/farms/' + Up.FARM_ID + '/document-storage/:tab',
  LIVESTOCK_BARN_INDEX: '/farms/' + Up.FARM_ID + '/livestock/barn',
  LIVESTOCK_BARN_VIEW: '/farms/' + Up.FARM_ID + '/livestock/barn/view/:id',
  LIVESTOCK_BARN_EDIT: '/farms/' + Up.FARM_ID + '/livestock/barn/edit/:id',
};

export const {
  HOMEPAGE,
  INFOPAGE,
  ABOUT,
  CONTACTS,
  TERMS,
  PRIVACY,
  HELP,
  LAD_EPS,

  LOGIN,
  LATVIJA_LV_AUTH,
  REGISTER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  DASHBOARD,
  ARTICLES_VIEW,
  EVENTS_VIEW,

  TOKENS_INDEX,
  TOKENS_CREATE,
  TOKENS_VIEW,
  TOKENS_EDIT,

  PROFILE,
  PROFILE_CHANGE_EMAIL,
  PROFILE_CHANGE_PASSWORD,
  PROFILE_CHANGE_PHONE,

  FARM_VIEW,
  FARM_EDIT,

  FARM_USERS_INDEX,
  FARM_USERS_CREATE,
  FARM_USERS_VIEW,
  FARM_USERS_EDIT,

  CROP_COUNTRY_MAPS,
  CROP_FIELDS_AND_WORKS_INDEX,
  CROP_FIELD_VIEW,
  CROP_FIELD_EDIT,
  CROP_FIELD_CREATE,
  CROP_FIELD_CREATE_LAD,
  CROP_FIELD_IMPORT,
  CROP_FIELDS_MERGE,
  CROP_FIELD_SPLIT,
  CROP_FIELD_ANALYSES_VIEW,
  CROP_FIELD_HISTORY,
  CROP_FIELD_HISTORY_VIEW,
  CROP_FIELD_HISTORY_OVERVIEW,
  CROP_WORK_CREATE,
  CROP_WORK_VIEW,
  CROP_WORK_EDIT,

  CROP_YIELD_ACCOUNTING_INDEX,
  CROP_YIELD_ACCOUNTING_CARGO_INDEX,
  CROP_YIELD_ACCOUNTING_CARGO_CREATE,
  CROP_YIELD_ACCOUNTING_CARGO_VIEW,
  CROP_YIELD_ACCOUNTING_CARGO_EDIT,
  CROP_CHANGE_PLAN_INDEX,
  CROP_CHANGE_PLAN_CREATE,
  CROP_CHANGE_PLAN_VIEW,
  CROP_CHANGE_PLAN_EDIT,
  CROP_FERTILIZATION_PLAN,
  CROP_FERTILIZATION_PLAN_VIEW,
  CROP_FERTILIZATION_PLAN_CREATE,
  CROP_FERTILIZATION_PLAN_EDIT,

  WAREHOUSE_MOVEMENT_INDEX,
  WAREHOUSE_DEAL_CREATE,
  WAREHOUSE_DEAL_VIEW,
  WAREHOUSE_DEAL_EDIT,
  WAREHOUSE_DEAL_COPY,
  WAREHOUSE_PRODUCTS_INDEX,
  WAREHOUSE_PRODUCTS_COPY,
  WAREHOUSE_PRODUCTS_CREATE,
  WAREHOUSE_PRODUCTS_VIEW,
  WAREHOUSE_PRODUCTS_EDIT,
  WAREHOUSE_WAREHOUSES_INDEX,
  WAREHOUSE_WAREHOUSES_CREATE,
  WAREHOUSE_WAREHOUSES_VIEW,
  WAREHOUSE_WAREHOUSES_EDIT,

  HUMAN_EMPLOYEES_INDEX,
  HUMAN_EMPLOYEES_CREATE,
  HUMAN_EMPLOYEES_VIEW,
  HUMAN_EMPLOYEES_EDIT,
  HUMAN_PARTNERS_INDEX,
  HUMAN_PARTNERS_CREATE,
  HUMAN_PARTNERS_VIEW,
  HUMAN_PARTNERS_EDIT,
  HUMAN_PARTNER_DEPARTMENTS_CREATE,
  HUMAN_PARTNER_DEPARTMENTS_EDIT,

  FINANCE_ANALYSIS_INDEX,
  FINANCE_BUDGET_INDEX,
  FINANCE_MODELING_INDEX,

  EQUIPMENT_LIST_INDEX,
  EQUIPMENT_LIST_CREATE,
  EQUIPMENT_LIST_VIEW,
  EQUIPMENT_LIST_EDIT,

  EQUIPMENT_MAINTENANCE_INDEX,
  EQUIPMENT_MAINTENANCE_CREATE,
  EQUIPMENT_MAINTENANCE_VIEW,
  EQUIPMENT_MAINTENANCE_EDIT,
  EQUIPMENT_FUEL_CONSUMPTION,

  REPORTING_BIOLOGICAL_FARMING_INDEX,
  REPORTING_VAAD_LIZ_REPORTS,
  REPORTING_VAAD_LIZ_REPORTS_CREATE,
  REPORTING_VAAD_LIZ_REPORTS_VIEW,
  REPORTING_VAAD_LIZ_REPORTS_UPDATE,
  REPORTING_REPORT_JOURNALS_INDEX,

  INTERNAL_LOGIN,
  INTERNAL_DASHBOARD,
  INTERNAL_HORIZON,
  INTERNAL_AUDIT_LOGS_INDEX,
  INTERNAL_AUDIT_LOGS_VIEW,
  INTERNAL_USERS_INDEX,
  INTERNAL_USERS_CREATE,
  INTERNAL_USERS_VIEW,
  INTERNAL_USERS_EDIT,
  INTERNAL_ROLES_INDEX,
  INTERNAL_ROLES_CREATE,
  INTERNAL_ROLES_VIEW,
  INTERNAL_ROLES_EDIT,
  INTERNAL_ARTICLES_INDEX,
  INTERNAL_ARTICLES_CREATE,
  INTERNAL_ARTICLES_VIEW,
  INTERNAL_ARTICLES_EDIT,
  INTERNAL_EVENTS_INDEX,
  INTERNAL_EVENTS_CREATE,
  INTERNAL_EVENTS_VIEW,
  INTERNAL_EVENTS_EDIT,
  INTERNAL_CLASSIFIERS_INDEX,
  INTERNAL_CLASSIFIER_VALUES,
  INTERNAL_CLASSIFIER_VALUE_CREATE,
  INTERNAL_CLASSIFIER_VALUE_VIEW,
  INTERNAL_CLASSIFIER_VALUE_EDIT,
  INTERNAL_CLASSIFIER_VALUE_CHILD_CREATE,
  INTERNAL_EMAIL_TEMPLATE_INDEX,
  INTERNAL_EMAIL_TEMPLATE_EDIT,
  INTERNAL_SYSTEM_PROPERTIES_INDEX,
  INTERNAL_SYSTEM_PROPERTIES_EDIT,

  INTERNAL_DEVELOPMENT_SANDBOX,
  SYSTEM_FILE,

  LIVESTOCK_ANIMALS_AND_EVENTS_INDEX,
  LIVESTOCK_ANIMALS_CREATE,
  LIVESTOCK_ANIMALS_EVENTS,
  LIVESTOCK_ANIMALS_GRAZING_CREATE,
  LIVESTOCK_ANIMALS_GRAZING_EDIT,
  LIVESTOCK_ANIMALS_GRAZING_VIEW,
  LIVESTOCK_ANIMALS_OTHER_CREATE,
  LIVESTOCK_ANIMALS_OTHER_EDIT,
  LIVESTOCK_ANIMALS_OTHER_VIEW,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_CREATE,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_EDIT,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_VIEW,
  LIVESTOCK_ANIMALS_SEPARATION_CREATE,
  LIVESTOCK_ANIMALS_SEPARATION_EDIT,
  LIVESTOCK_ANIMALS_SEPARATION_VIEW,
  LIVESTOCK_ANIMALS_BREEDING_CREATE,
  LIVESTOCK_ANIMALS_BREEDING_EDIT,
  LIVESTOCK_ANIMALS_BREEDING_VIEW,
  LIVESTOCK_ANIMALS_WEIGHING_CREATE,
  LIVESTOCK_ANIMALS_WEIGHING_EDIT,
  LIVESTOCK_ANIMALS_WEIGHING_VIEW,
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_CREATE,
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_EDIT,
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_VIEW,
  LIVESTOCK_ANIMALS_VIEW,
  LIVESTOCK_FODDER_NEED_INDEX,
  LIVESTOCK_FODDER_NEED_CREATE,
  LIVESTOCK_FODDER_NEED_EDIT,
  LIVESTOCK_FODDER_NEED_VIEW,
  
  LIVESTOCK_SUMMARY_INDEX,
  LIVESTOCK_SUMMARY_VIEW,
  LIVESTOCK_METABOLISM_VIEW,
  LIVESTOCK_SOMATIC_CELLS_VIEW,
  LIVESTOCK_REPRODUCTION_VIEW,

  DOCUMENT_STORAGE_INDEX,

  LIVESTOCK_BARN_INDEX,
  LIVESTOCK_BARN_VIEW,
  LIVESTOCK_BARN_EDIT,
} = ROUTES;

export default ROUTES;
